import { render, staticRenderFns } from "./conflictDetailsDialog.vue?vue&type=template&id=1f2af4fc&scoped=true"
import script from "./conflictDetailsDialog.vue?vue&type=script&lang=js"
export * from "./conflictDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./conflictDetailsDialog.vue?vue&type=style&index=0&id=1f2af4fc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2af4fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f2af4fc')) {
      api.createRecord('1f2af4fc', component.options)
    } else {
      api.reload('1f2af4fc', component.options)
    }
    module.hot.accept("./conflictDetailsDialog.vue?vue&type=template&id=1f2af4fc&scoped=true", function () {
      api.rerender('1f2af4fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/firmware/taskList/components/conflictDetailsDialog.vue"
export default component.exports